export const ADD_SCENE = 'ADD_SCENE';
export const DELETE_SCENE = 'DELETE_SCENE';
export const CHANGE_ORDER_SCENE = 'CHANGE_ORDER_SCENE';
export const REMOVE_ALL_AND_ADD = 'REMOVE_ALL_AND_ADD';


